import { useEffect, useState } from 'react';

import { useIsMobile } from 'src/app/shared/hooks/userAgent';
import { getNavigatorShareInterface } from 'src/app/shared/share/utils';

export function useIsMobileNativeShareCapable(): boolean {
	const isMobile = useIsMobile();
	const [capable, setCapable] = useState<boolean>(isMobile); // we assume capable by default
	// we are using a useEffect because we want to check when on the client only, to avoid hydration issues
	// this could result in a flicker (disappearing button) on older mobile devices that do not support the canShare API
	useEffect(() => {
		if (!isMobile) {
			return;
		}
		if (!getNavigatorShareInterface()) {
			// eslint-disable-next-line react-hooks/set-state-in-effect
			setCapable(false);
		}
		// oxlint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return capable;
}
